export default {
	computed:{
		userdata(){
      return this.$store.state.AppData.data.userdata;
    },
	}
}